var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotFound(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.8899 23.0344L30.825 28.9695L30.8204 28.9741L31.5 29.6538L29.652 31.5065L28.9724 30.8268L23.0373 24.8871C18.5499 28.4574 12.0003 28.1688 7.84809 24.0166C3.38397 19.5525 3.38397 12.3094 7.84809 7.84523C12.3122 3.37646 19.5507 3.37646 24.0195 7.84523C28.1764 11.9975 28.4603 18.547 24.8899 23.0344ZM9.69146 22.1686C13.1315 25.6133 18.7314 25.6133 22.1761 22.1686C25.6208 18.7286 25.6208 13.124 22.1761 9.68395C18.7361 6.24392 13.1361 6.24392 9.69146 9.68395C6.24678 13.124 6.24678 18.7286 9.69146 22.1686ZM15.9339 14.0689L19.2622 10.736L21.1242 12.6026L17.7959 15.9309L21.1242 19.2592L19.2622 21.1212L15.9339 17.7929L12.601 21.1212L10.7436 19.2592L14.0719 15.9309L10.7436 12.6026L12.601 10.736L15.9339 14.0689Z",
    fill: "#ACCAF8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/NotFound.526882ab6b812a4524c2177315a9482a.svg";
export { ForwardRef as ReactComponent };